/* Developed by Sukh Sandhu. Keep product context separate from an optional training code. */
(function(root){
 'use strict';
 const normal=s=>String(s||'').toLowerCase().replace(/&/g,' and ').replace(/[^a-z0-9]+/g,' ').trim();
 function selection(resource,explicit,values){
  const reference=String(resource||'').trim().slice(0,350),text=' '+normal(reference)+' ';
  const options=values.filter(Boolean).slice().sort((a,b)=>b.length-a.length);
  const supplied=typeof explicit==='string'?explicit.trim():'';
  const format=supplied?(options.find(x=>x===supplied)||''):(options.find(x=>text.includes(' '+normal(x)+' '))||'');
  const code=reference.match(/\b(?:[A-Z]{2,12}\d{3,8}[A-Z]{0,2}|\d{5}(?:NAT|VIC))\b/i)?.[0]?.toUpperCase()||'';
  return {reference,format,code};
 }
 function sameContext(initial,code,format){return String(code||'').trim().toUpperCase()===initial.code&&(!initial.format||format===initial.format);}
 if(typeof module==='object'&&module.exports){module.exports={selection,sameContext};return;}
 const setup=()=>{
  const field=document.getElementById('sample-code'),format=document.getElementById('sample-type');
  if(!field||!format||field.dataset.sampleContextInitialized)return;
  const params=new URLSearchParams(location.search),initial=selection(params.get('resource'),params.get('resource_format'),[...format.options].map(x=>x.value));
  if(!initial.reference&&!initial.format)return;
  field.dataset.sampleContextInitialized='true';format.value=initial.format;
  if(!initial.reference)return;
  // Never leave a whole webinar/product title in the unit-code input.
  field.value=initial.code;
  const builder=field.closest('.brief-builder');let note;
  if(builder){
   note=document.createElement('p');note.className='sample-resource-reference';note.dataset.sampleResourceContext='';note.style.maxWidth='72ch';
   const label=document.createElement('strong');label.textContent='Resource referenced: ';
   const text=document.createElement('span');text.textContent=initial.reference;note.append(label,text);builder.before(note);
  }
  const update=()=>{const active=sameContext(initial,field.value,format.value);field.dataset.sampleResourceTitle=active?initial.reference:'';if(note)note.hidden=!active;};
  field.addEventListener('input',update);field.addEventListener('change',update);format.addEventListener('change',update);update();
 };
 if(document.readyState!=='complete')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
})(typeof window==='undefined'?globalThis:window);
